import { render } from "./modal-tags.vue?vue&type=template&id=d9849b7c"
import script from "./modal-tags.vue?vue&type=script&lang=js"
export * from "./modal-tags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__